import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-qty-with-tooltip-cell-renderer',
  templateUrl: './qty-with-tooltip-cell-renderer.component.html',
  styleUrls: ['./qty-with-tooltip-cell-renderer.component.scss']
})
export class QtyWithTooltipCellRendererComponent implements OnInit,OnDestroy {
  params
  constructor() { }
  private destroy$ = new Subject<void>();
  ngOnInit(): void {
  }
  agInit(params: any): void {
    this.params = params.data;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }


}
